(function () {
  function forceCleanMenu(drawer, details, summary) {
    if (details) {
      details.classList.remove('menu-opening');
      details.querySelectorAll('details').forEach(function (submenu) {
        submenu.removeAttribute('open');
        submenu.classList.remove('menu-opening');
      });
      details.querySelectorAll('.submenu-open').forEach(function (submenu) {
        submenu.classList.remove('submenu-open');
      });
      details.removeAttribute('open');
    }

    if (summary) summary.setAttribute('aria-expanded', 'false');
    ['overflow-hidden-tablet', 'overflow-hidden-desktop', 'overflow-hidden-mobile'].forEach(function (className) {
      document.body.classList.remove(className);
    });
    document.querySelector('.section-header')?.classList.remove('menu-open');
    if (drawer && drawer.header) drawer.header.classList.remove('menu-open');
  }

  function closeLuxuryMenu(drawer) {
    if (!drawer) return;

    var details = drawer.querySelector(':scope > #Details-menu-drawer-container, #Details-menu-drawer-container');
    var summary = details && details.querySelector(':scope > summary');
    if (!details) return;

    drawer.header = drawer.header || document.querySelector('.section-header');

    try {
      if (typeof drawer.closeMenuDrawer === 'function' && details.hasAttribute('open') && summary) {
        drawer.closeMenuDrawer(new Event('click'), summary);
        summary.setAttribute('aria-expanded', 'false');
        window.setTimeout(function () {
          forceCleanMenu(drawer, details, summary);
        }, 460);
        return;
      }
    } catch (error) {
      forceCleanMenu(drawer, details, summary);
      return;
    }

    forceCleanMenu(drawer, details, summary);
  }

  document.addEventListener(
    'click',
    function (event) {
      var closeButton = event.target.closest('[data-luxury-menu-close]');
      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        closeLuxuryMenu(closeButton.closest('header-drawer'));
        return;
      }

      var openDetails = document.querySelector('header-drawer #Details-menu-drawer-container[open]');
      if (!openDetails) return;

      var clickedInsideDrawer = event.target.closest('#menu-drawer');
      var clickedMenuToggle = event.target.closest('.header__icon--menu');
      if (!clickedInsideDrawer && !clickedMenuToggle) {
        closeLuxuryMenu(openDetails.closest('header-drawer'));
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var openSearch = document.querySelector('details-modal.header__search details[open]');
      if (!openSearch) return;

      var clickedPanel = event.target.closest('.search-modal__content');
      var clickedSearchToggle = event.target.closest('.header__icon--search');
      if (clickedPanel || clickedSearchToggle) return;

      var modal = openSearch.closest('details-modal');
      if (modal && typeof modal.close === 'function') {
        modal.close(false);
      } else {
        openSearch.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
    },
    true
  );

  function revealHomeSections() {
    if (!document.body.classList.contains('template-index')) return;

    var sections = Array.prototype.slice.call(document.querySelectorAll('.luxury-section'));
    if (!sections.length) return;

    sections.slice(2).forEach(function (section, index) {
      section.classList.add('luxury-scroll-reveal');
      section.style.setProperty('--luxury-reveal-delay', Math.min(index * 55, 220) + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('luxury-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('luxury-in-view');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    sections.forEach(function (section) {
      if (section.classList.contains('luxury-scroll-reveal')) observer.observe(section);
      else section.classList.add('luxury-in-view');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealHomeSections);
  } else {
    revealHomeSections();
  }
})();
